import React, { useState } from "react";
import { formatLongDate } from "../../../../util/Helpers";
import { ContentRoute } from "../../../../../_metronic/layout";
import { AsideMenu } from "../../../Common/layout/aside/AsideMenu";
import { Permission } from "../../../Common/layout/Permission";
import { Permissions, PermissionType } from "../../../../util/Permissions";
import CreateBillingModal from "../modals/CreateBillingModal";
import { useGetBillingHistoryQuery } from "../../../../../redux/apiSlice";
import { BillingDetails } from "./BillingDetails";


export const BillingHistory = ({ userGroup, billingId }) => {


    const { data: billings } = useGetBillingHistoryQuery()


    /* Maintenance Fee Modal State Management */
    const [billingModal, setBillingModal] = useState({ showCreateBillingModal: false, details: null });

    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setBillingModal({ ...billingModal, [modal]: !billingModal[modal] })
    }


    return <>
        <div className="d-flex h-100">
            <div
                style={{ "width": "280px"}}
                className="border-right d-flex flex-column"
            >
                <div className="py-4 px-5">
                    <p className="text-muted m-0">Maintenance Fee History</p>
                </div>
                <div className="col px-0 " style={{ maxHeight: "100%" }}>
                    {
                        billings?.data?.map((billing, i) => (
                            <AsideMenu.NavItem key={billing?.autoId} to={`/maintenance/${billing?.userGroup}/accounts/billing-history/${billing?.autoId}`}>
                                <div className="d-flex align-items-center">
                                    <div className="flex-column align-items-start">
                                        <div>
                                            {formatLongDate(billing?.created)}
                                        </div>
                                        <div className="text-muted">
                                            From {formatLongDate(billing?.periodStartDate)} to {formatLongDate(billing?.periodEndDate)}
                                        </div>
                                    </div>
                                </div>
                            </AsideMenu.NavItem>
                        ))
                    }
                </div>
                <Permission permission={Permissions.PROFILE} permissionType={PermissionType.CREATE}>
                    <div className="bg-white border-top mx-5">
                        <button
                            className={`btn btn-dark w-100 h-40 my-2 my-lg-3`}
                            onClick={toggleModal("showCreateBillingModal")}
                        >
                            Create Billing Action
                        </button>
                    </div>
                </Permission>
            </div>
            <div className="col px-0">
                <ContentRoute
                    path="/maintenance/:userGroup/accounts/billing-history/:billingId"
                    permission={Permissions.MAINTENANCE_FEE}
                    component={(props) => <BillingDetails {...props} />}
                />
            </div>
        </div>
        <CreateBillingModal
            {...billingModal}
            onHide={toggleModal("showCreateBillingModal")}
        />

    </>;
};
